import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import BaseListPage from "../../../base/BaseListPage";
import DiscountDistributionPresenter from "./DiscountDistributionPresenter";
import {
  countObjectUseCase,
  findObjectUseCase,
} from "../../../usecases/object";
import withRouter from "../../../withRouter";
import DateRangeReport from "../../../components/DateRangeReport";
import DefaultState from "../../sales-and-transactions/components/DefaultState";
import InitialPrompt from "../../../components/InitialPrompt";
import ProgressLoader from "../../../components/ProgressLoader";
import PageHeader from "../../../components/PageHeader";
import CustomSelect from "../../../components/CustomSelect";

class DiscountDistributionPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new DiscountDistributionPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
    );
    this.state = {
      objects: [],
      startDate: "",
      endDate: "",
      selectedStoreCode: "",
      store: [],
      storess: "",
      range: "",
      notFound: false,
    };
  }

  getCollectionName() {
    return "transactions";
  }
  setStore(store) {
    this.setState({ store });
  }
  onChangeDate(where) {
    this.presenter.onChangeDate(where);
    this.setState({ range: where });
  }

  onChangeStore(where) {
    this.setState({ storess: where });
    this.presenter.onChangeStore(where);
  }

  countTransactionTypesFromMonth = (transactions, month, year) => {
    let totalGuest = 0;
    let totalTransaction = 0;

    transactions.forEach((transaction) => {
      const transactionDate = new Date(transaction.tran_date);
      if (
        transactionDate.getMonth() === month &&
        transactionDate.getFullYear() === year
      ) {
        totalGuest += Number(transaction.cust_count || "0");
        totalTransaction += 1;
      }
    });

    return { totalGuest, totalTransaction };
  };

  getHighchartsOptions() {
    const discountMap = {};

    this.state.objects.forEach((tx) => {
      const name = tx.discount_name;
      if (!name) return;
      const amt = parseFloat(tx.discount_amount) || 0;
      if (!discountMap[name]) {
        discountMap[name] = { total: 0, count: 0 };
      }
      discountMap[name].total += amt;
      discountMap[name].count += 1;
    });

    const colors = [
      "#ff6384", "#36a2eb", "#ffce56", "#4bc0c0", "#9966ff",
      "#ff9f40", "#ea4335", "#34a853", "#4285f4", "#fbbc05",
    ];

    const data = Object.entries(discountMap)
      .filter(([, v]) => v.total > 0)
      .map(([name, v], i) => ({
        name: `${name} (${v.count})`,
        y: parseFloat(v.total.toFixed(2)),
        count: v.count,
        color: colors[i % colors.length],
      }));

    return {
      chart: { type: "pie" },
      title: { text: null },
      tooltip: {
        pointFormat:
          "<b>{point.y:.2f}</b> PHP ({point.percentage:.1f}%)<br/>Count: {point.count}",
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          dataLabels: {
            enabled: true,
            format:
              "<b>{point.name}</b>: \u20B1{point.y:,.2f} ({point.percentage:.1f}%)",
          },
          showInLegend: true,
        },
      },
      series: [
        {
          name: "Discount Amount",
          colorByPoint: true,
          data,
        },
      ],
      credits: { enabled: false },
    };
  }

  getProgressPercentage() {
    const { objects, count } = this.state;
    if (!count || count === 0) return 0;
    return Math.min(Math.round((objects.length / count) * 100), 100);
  }

  setNotFound(notFound) {
    this.setState({ notFound });
  }

  render() {
    const chartOptions = this.getHighchartsOptions();

    return (
      <>
        <div className=" d-flex justify-content-between align-items-center mb-1 mt-4">
          <PageHeader
            title="Discount Type Distribution"
            subtitle="Breakdown of transactions by discount type"
            icon="bi bi-percent"
          />
        </div>

        <div className="row mb-2">
          <div className="col" style={{ maxWidth: "max-content" }}>
            <DateRangeReport
              onChange={this.onChangeDate.bind(this)}
              field="tran_date"
            />
          </div>
          <div className="col-sm-4">
            <CustomSelect
              label="Store"
              options={[
                ...this.state.store.map((store) => ({
                  value: store.name,
                  label: store.name.replace(/_/g, " "),
                })),
              ]}
              onChange={(selected) => this.onChangeStore(selected.value)}
              icon="bi bi-shop"
              placeholder="Select Store"
              isClearable={true}
            />
          </div>
        </div>

        <ProgressLoader
          loaded={this.state.objects?.length}
          total={this.state.count}
          getProgressPercentage={() => this.getProgressPercentage()}
        />

        <div className="">
          {this.state.objects && this.state.objects.length > 0 ? (
            <div className="card p-4">
              <HighchartsReact highcharts={Highcharts} options={chartOptions} />
            </div>
          ) : this.state.notFound ? (
            <div className="text-center mt-5">
              <p className="text-muted fs-5">
                📭 Data not found for selected filter.
              </p>
            </div>
          ) : this.state.storess && this.state.range ? (
            <div className="text-center mt-5">
              <DefaultState />
            </div>
          ) : (
            <InitialPrompt twoFilter={true} />
          )}
        </div>
      </>
    );
  }
}

export default withRouter(DiscountDistributionPage);
